enum UI_MODES {
	// Editable, rearrangeable
	// E.g. editable outline page
	// TODO: Implement
	STANDARD = "Standard",

	// Shows check boxes next to outline objects for selection
	// E.g. AI brainstorm selection
	// TODO: Implement
	SELECT = "Select",

	// Not editable or rearrangeable
	// E.g. outline page but the project is locked or you don't have edit access to it
	// TODO: Implement
	READONLY = "Read-only",

	// Editable
	// E.g. extension
	// TODO: Implement
	SIDEBAR = "Sidebar",

	// Not editable
	// E.g. composer review. Might be the same as READONLY
	// TODO: Implement
	SIDEBAR_READONLY = "Sidebar (read-only)",

	// Not editable, annotations can be dragged outside of the sidebar
	// E.g. the sidebar used for composer
	SIDEBAR_DRAG = "Sidebar (drag)"
}

export default UI_MODES;
